import React, {useState,useEffect,Fragment,lazy,Suspense} from 'react';
import { imageSet } from '../helper/Images';
import { FormattedHTMLMessage, FormattedMessage, useIntl } from 'react-intl';
import content from 'Content/content.json';
import QuizBanner from './banner/quizBanner';
import PromoBanner from './banner/promoBanner';
import VirtualMirrorBanner from './banner/virtualMirrorBanner';
const CenterNavigation = lazy(() => import('./centernavigation'));
const RightBackgroundSection = lazy(() => import('./background/rightSection'));
const LeftBackgroundSection = lazy(() => import('./background/leftSection'));
import Appsflyer from 'Components/helper/Appsflyer';
import { LANG_JP, language, showQuiz, showPromo, pageDefaultTitle, LANG_RU, LANG_ARABIA, LANG_ARABIA_EN } from 'Root/constants';
import './home.scss';
import { LANG_AZ } from '../../constants';
import Banner from '../banner';
import AnimationModule from '../animationModule';
import HomeAppPromo from "./homeapppromo";
import ShopNow from '../showNow';
import { Helmet } from 'react-helmet';
import { ReferencesDiscover as References } from "Components/references";

const imgs = {
  promo_banner: imageSet[content['data']['homepage_cards'][language]['promo_card']],
  beauty_advisor_btn: imageSet[content['data']['homepage_cards'][language]['quiz_card']],
  vm_btn_img: imageSet[content['data']['homepage_cards'][language]['model_card']]
}

const initialState = {
  showCamPopUp: false,
  cookieSlideUp: false
};

const Home = (props) => {
  const [stateObj, setStateObj] = useState(initialState);
  useEffect(() => {
    setStateObj(prevState => ({
      ...prevState,
      cookieSlideUp: true
    }));
  }, []);

  const {
    data: {
      homepage_cards: {
        [language]: { promo_card, quiz_card, model_card },
      },
    },
  } = content;

  useEffect(() => {
    document.body.classList.add("home");
    return () => {
      document.body.classList.remove("home");
    };
  });

  useEffect(() => {
    if(language === LANG_JP) {
      document.title = pageDefaultTitle + "|home";
      return () => {
        document.title = pageDefaultTitle;
      }
    }
  });


  useEffect(() => {
    setStateObj(prevState => ({
      ...prevState,
      cookieSlideUp: true
    }));
  }, []);

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'meta.title.home', defaultMessage: '1-DAY ACUVUE® DEFINE®' });
  const description = intl.formatMessage({ id: 'meta.desc.home', defaultMessage: 'Science, art and technology-backed daily disposable lenses crafted for the best of beauty, comfort and health.' });

  return (
    <React.Fragment>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
      <main>
        <Banner></Banner>
        <AnimationModule></AnimationModule>
        <HomeAppPromo></HomeAppPromo>
        <ShopNow/>
      </main>
      { (language == "id") && (
        <References>
          <FormattedHTMLMessage
            id="home_references"
          />
        </References>
      )}
    </React.Fragment>
  );
};

export default Home;
